import { Sitemap } from "@iventis/domain-model/model/sitemap";
import { SitemapVersion } from "@iventis/domain-model/model/sitemapVersion";
import { SitemapVersionLevel } from "@iventis/domain-model/model/sitemapVersionLevel";
import { SitemapVersionLevelCadConfig } from "@iventis/domain-model/model/sitemapVersionLevelCadConfig";
import { SitemapVersionLevelUploadMethod } from "@iventis/domain-model/model/sitemapVersionLevelUploadMethod";
import { TreeBrowserNode, TreeBrowserStateInterface, UnionOfNodes } from "@iventis/tree-browser";
import { SitemapVersionLevelCreateRequest as _SitemapVersionLevelCreateRequest } from "@iventis/domain-model/model/sitemapVersionLevelCreateRequest";
import { Polygon } from "geojson";
import React from "react";

export interface SitemapVersionLevelMbtiles extends Omit<SitemapVersionLevel, "perimeter"> {
    mbtiles?: File;
    style?: File;
    uploadMethod: SitemapVersionLevelUploadMethod.Mbtiles;
    perimeter: string;
}

export interface SitemapVersionLevelPMtiles extends Omit<SitemapVersionLevel, "perimeter"> {
    pmtiles?: File;
    style?: File;
    uploadMethod: SitemapVersionLevelUploadMethod.PMtiles;
    perimeter: string;
}

export interface SitemapVersionLevelCad extends Omit<SitemapVersionLevel, "perimeter"> {
    cad?: File;
    cadConfig?: SitemapVersionLevelCadConfig;
    uploadMethod: SitemapVersionLevelUploadMethod.Cad;
    perimeter: string;
}

export type SitemapVersionLevelCadWithConfig = SitemapVersionLevelCad;

export type SitemapVersionLevelWithFiles = SitemapVersionLevelMbtiles | SitemapVersionLevelPMtiles | SitemapVersionLevelCadWithConfig;

export interface SitemapVersionWithFiles extends Omit<SitemapVersion, "sitemapVersionLevels"> {
    sitemapVersionLevels: SitemapVersionLevelWithFiles[];
}

export interface SitemapTreeBrowserNode extends TreeBrowserNode {
    type: SiteMapNodeTypes;
}

export interface SitemapRootNode extends SitemapTreeBrowserNode {
    type: SiteMapNodeTypes.Root;
    childNodes: SitemapNode[];
}

export interface SitemapNode extends SitemapTreeBrowserNode {
    type: SiteMapNodeTypes.Sitemap;
    sitemap: Sitemap;
    childNodes: SitemapVersionNode[];
}

export interface SitemapVersionNode extends SitemapTreeBrowserNode {
    type: SiteMapNodeTypes.Version;
    version: SitemapVersion;
    childNodes: SitemapVersionLevelNode[];
}

export interface SitemapVersionLevelNode extends SitemapTreeBrowserNode {
    type: SiteMapNodeTypes.Level;
    level: SitemapVersionLevel;
    childNodes: [];
}

export enum SiteMapNodeTypes {
    Sitemap = "Sitemap",
    Version = "Version",
    Level = "Level",
    Root = "Sitemap-Root",
}

export type AnySitemapTreeNode = UnionOfNodes<SitemapRootNode>;

export const SitemapTreeBrowserContext = React.createContext<TreeBrowserStateInterface<SitemapRootNode>>(null);

export type SitemapVersionLevelCreateRequest = Omit<_SitemapVersionLevelCreateRequest, "style" | "perimeter"> & { style?: Object; perimeter?: Polygon };
